import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-fixed-editor',
  templateUrl: './fixed-editor.component.html',
  styleUrls: ['./fixed-editor.component.css']
})
export class FixedEditorComponent implements OnInit {
  @Input() element

  openEditor: boolean = false;
  constructor() { }

  ngOnInit() {
  }

}
